import React, { useEffect, useState } from 'react'

const ImageSlider = ({ itemImage }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  const handleHover = index => {
    setActiveIndex(index)
  }

  useEffect(() => {
    setActiveIndex(0)
  }, [itemImage])

  return (
    <div className="prdi__image">
      <div className="slideshow">
        <div className="slideshow-lead">
          {itemImage.map((image, index) => (
            <img
              key={index}
              className={`slideshow-items ${index === activeIndex ? 'active' : ''}`}
              src={image.largeUrl}
              // loading="lazy"
            />
          ))}
        </div>

        <div className="slideshow-mini">
          {itemImage.map((image, index) => (
            <img
              key={index}
              className={`slideshow-thumbnails ${index === activeIndex ? 'active' : ''}`}
              src={image.largeUrl}
              onMouseEnter={() => handleHover(index)}
              // loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ImageSlider
